<template>
  <div class="modal-criarConta">
    <img
      src="@/assets/icons/close.svg"
      alt="Botão de fechar"
      class="button-close"
      @click="close"
    />

    <h1 class="modal__title">Cadastre-se agora</h1>

    <ValidationObserver v-slot="{ invalid }">
      <form class="modal__form" @submit.prevent="submitNewAccount">
        <ValidationProvider v-slot="{ errors }" rules="alpha|required">
          <input
            ref="inputNome"
            v-model="newAccount.firstName"
            type="text"
            placeholder="Nome"
            class="modal__form--input-text"
          />
          <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>

        <ValidationProvider v-slot="{ errors }" rules="alpha|required">
          <input
            v-model="newAccount.lastName"
            type="text"
            placeholder="Sobrenome"
            class="modal__form--input-text"
          />
          <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>

        <ValidationProvider v-slot="{ errors }" rules="required">
          <input
            v-model="newAccount.title"
            type="text"
            placeholder="Profissão"
            class="modal__form--input-text"
          />
          <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>

        <div class="modal__form-middle">
          <ValidationProvider v-slot="{ errors }" rules="email|required">
            <input
              v-model="newAccount.email"
              type="email"
              placeholder="E-mail"
              class="modal__form--input-text"
            />
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" rules="numeric|required">
            <the-mask
              v-model="newAccount.phone"
              class="modal__form--input-text"
              placeholder="Telefone"
              :mask="['(##) ####-####', '(##) #####-####']"
            />
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <ValidationProvider v-slot="{ errors }" rules="required">
          <input
            v-model="newAccount.location"
            type="text"
            placeholder="Endereço"
            class="modal__form--input-text"
          />
          <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>

        <ValidationProvider v-slot="{ errors }" rules="required">
          <input
            v-model="newAccount.about"
            type="text"
            placeholder="Sobre você"
            class="modal__form--input-text"
          />
          <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>

        <div class="modal__form-middle">
          <ValidationProvider v-slot="{ errors }" rules="alpha_num|required">
            <input
              v-model="newAccount.facebook"
              type="text"
              placeholder="Facebook"
              class="modal__form--input-text"
            />
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" rules="alpha_num|required">
            <input
              v-model="newAccount.twitter"
              type="text"
              placeholder="Twitter"
              class="modal__form--input-text"
            />
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" rules="alpha_num|required">
            <input
              v-model="newAccount.linkedin"
              type="text"
              placeholder="Linkedin"
              class="modal__form--input-text"
            />
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <h2 class="modal__form-subtitle">
          Informações de login
          <span class="info"
            >a senha atual é necessária para atualizar o e-mail ou alterar a
            senha</span
          >
        </h2>

        <div class="modal__form-middle">
          <ValidationObserver>
            <ValidationProvider
              v-slot="{ errors }"
              rules="confirmed:confirmation|required"
            >
              <input
                v-model="newAccount.password"
                type="password"
                placeholder="Escolha sua senha"
                class="margin-right modal__form--input-text"
              />
              <span class="error">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider v-slot="{ errors }" vid="confirmation">
              <input
                v-model="newAccount.confirm"
                type="password"
                placeholder="Confirmar a senha"
                class="modal__form--input-text"
              />
              <span class="error">{{ errors[0] }}</span>
            </ValidationProvider>
          </ValidationObserver>
        </div>

        <span class="modal__form--group-checkbox">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="{ required: { allowFalse: false } }"
          >
            <input
              id="checkboxLembrar"
              v-model="newAccount.term"
              type="checkbox"
            />
            <label for="checkboxLembrar"
              >Eu li, entendi e aceito os Termos de uso e serviço</label
            >
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </span>

        <button :disabled="invalid" class="modal__form--button">
          Criar conta
        </button>
      </form>
    </ValidationObserver>
  </div>
</template>


<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { TheMask } from 'vue-the-mask';
import ValidateField from '@/service/mixins/validation.js';
import axios from 'axios';

export default {
  name: 'NewAccount',

  components: {
    ValidationObserver,
    ValidationProvider,
    TheMask,
  },

  mixins: [ValidateField],

  data() {
    return {
      newAccount: {
        userId: '',
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        password: this.password,
        phone: this.phone,
        about: this.about,
        location: this.location,
        facebook: this.facebook,
        twitter: this.twitter,
        linkedin: this.linkedin,
        term: false,
      },
      showWarning: true,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.inputNome.focus();
    });
  },

  methods: {
    close() {
      this.$emit('close');
    },

    async submitNewAccount() {
      const user = await axios
        .post(`${process.env.VUE_APP_API}/user/register`, {
          email: this.newAccount.email,
          password: this.newAccount.password,
          firstName: this.newAccount.firstName,
          lastName: this.newAccount.lastName,
          phone: this.newAccount.phone,
          about: this.newAccount.about,
          location: this.newAccount.location,
        })
        .catch((error) => {
          console.error(error.response.data);
          alert(error.response.data.message);
        });
      if (user) {
        alert('Email cadastrado com sucesso');
      }

      // await axios.post(`${process.env.VUE_APP_API}/profile`, {
      //   userId: user.data.id,
      //   firstName: this.newAccount.firstName,
      //   lastName: this.newAccount.lastName,
      //   title: this.newAccount.title,
      //   location: this.newAccount.location,
      //   phone: this.newAccount.phone,
      //   facebook: this.newAccount.facebook,
      //   twitter: this.newAccount.twitter,
      //   linkedin: this.newAccount.linkedin,
      //   about: this.newAccount.about
      // })
      //   .then(() => {
      //     this.$root.$emit('warning')
      //     this.close()
      //   })
    },
  },
};
</script>


<style lang="scss" scoped>
.modal-criarConta {
  background: white;
  position: relative;

  padding: 30px 60px;
  width: 100%;
  max-width: 800px;
  position: relative;

  .button-close {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .modal__title {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 24px;
    color: #1e2e42;
    margin-bottom: 40px;
  }

  .modal__form {
    .error {
      color: red;
      display: block;
    }

    &--input-text {
      width: 100%;
      border: 1px solid rgba(0, 0, 0, 0.32);
      font-size: 14px;
      color: #000;
      padding: 10px;
      border-radius: 4px;
      margin: 8px 0;

      &::placeholder {
        color: #6b6b6b;
      }
    }

    &-middle {
      display: flex;
      justify-content: space-between;
      gap: 10px;

      span {
        width: 100%;
      }
    }

    &-subtitle {
      font-weight: 500;
      font-size: 16px;
      color: #3a3b3f;
      letter-spacing: -0.05px;
      margin: 20px 0;

      .info {
        color: #66788a;
        font-size: 14px;
        font-weight: 400;
      }
    }

    &--group-checkbox {
      display: flex;
      align-items: center;
      padding: 10px 0;
      gap: 10px;

      #checkboxLembrar {
        margin-right: 5px;
      }
    }

    &--button {
      width: 100%;
      background: #1d43ff;
      border-radius: 4px;
      color: #fff;
      font-size: 14px;
      line-height: 16px;
      border: none;
      padding: 14px;
      cursor: pointer;
      font-family: 'Roboto 500', sans-serif;

      &:disabled {
        background: gray;
        cursor: pointer;
      }
    }
  }
}

@media (max-width: 768px) {
  .modal-criarConta {
    width: 348px;
    padding: 20px;

    .middle {
      flex-direction: column;

      input {
        width: 100%;
      }

      input[type='email'],
      .margin-right {
        width: 100%;
      }
    }

    h2 {
      span {
        display: block;
      }
    }

    .group-checkbox {
      label {
        font-size: 12px;
      }
    }
  }
}
</style>